import { cloudChiprApi } from "../../../../services/cloudchipr.api";

export const dashboardHierarchySelector =
  cloudChiprApi.endpoints.getUsersMeOrganisationsCurrentDashboardHierarchy.select(
    {},
  );
